module.exports = __webpack_public_path__ + "img/main01.ed1562f5.jpg";